import { $i18n } from "./i18n";
export * from "@alife/cn-i18n";
export { withI18n } from "./hoc";
export { useI18n } from "./hooks";
export { PandaConfigProvider } from "./components/PandaConfigProvider";
export { PandaSwitcher } from "./components/PandaSwitcher";
export default $i18n;
